export const MAPBOX_TOKEN =
    'pk.eyJ1Ijoicm9hZGduYXIiLCJhIjoiY2tsb3BjanA4MHY2eDJ5cXBjdXNndDJyOCJ9.8gLZYamV12YMA5sOmOALCg';

export const FOV_FILL_COLOR = 'rgba(0, 187, 174, 0.4)';
export const FOV_STROKE_COLOR = 'rgba(0, 187, 174, 0.8)';

// Default location for maps when no data is available (set to Greentown Labs)
export const DEFAULT_MAP_LOCATION = {
    longitude: -71.1026937,
    latitude: 42.3820702,
    zoom: 20,
};

